import { createFileRoute } from "@tanstack/react-router";
import TriedEverythingMoneyCanBuy from "@/pages/articles/TriedEverythingMoneyCanBuy";
export const Route = createFileRoute("/youve-tried-everything-money-can-buy")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Youve Tried Everything Money Can Buy | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Tried everything money can buy for depression? SAINT TMS and SPRAVATO offer new options when nothing else has worked. Learn more in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Youve Tried Everything Money Can Buy | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Tried everything money can buy for depression? SAINT TMS and SPRAVATO offer new options when nothing else has worked. Learn more in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/youve-tried-everything-money-can-buy",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/youve-tried-everything-money-can-buy",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TriedEverythingMoneyCanBuy />;
}
